import axios from 'axios';
// import { reNewPluginAccessKeyToken } from './integrations';

const socialLogin = async (requestDto) => {
  try {
    const response = await axios.post(`${process.env.REACT_APP_BACKEND_BASE_URL}/auth/social/token`, requestDto);
    const token = response.data.accessToken
      || response.data?.token
      || response.data?.data?.accessToken
      || response.data?.data?.token
      || response.data?.userResponse?.accessToken;
    if (token) {
      localStorage.setItem('token', token);
    }
    return response.data;
  } catch (err) {
    throw err.response;
  }
};

export default socialLogin;
